// extracted by mini-css-extract-plugin
export default {"cta":"TF-z","disabled":"UF-z"};